import permissions from '@/constants/permissions'

const NextEditionCoordinatorQuestionnaire = () =>
  import('@/views/nextEditionDocument/NextEditionCoordinatorQuestionnaire.vue')

export default {
  path: 'rekomendacja-koordynatora',
  name: 'NextEditionCoordinatorRecommendation',
  component: NextEditionCoordinatorQuestionnaire,
  meta: {
    requireAuth: true,
    permission: [
      permissions.nextEditionRecommendationAdd,
      permissions.nextEditionRecommendationAddCoordinator,
      permissions.nextEditionRecommendationView,
      permissions.nextEditionRecommendationViewCoordinator
    ]
  }
}
